import DOMPurify from 'dompurify'

/** Sanitises HTML that came from an email before it's loaded into our own editor (quoted replies/forwards). */
export function sanitizeQuoted(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'img', 'form', 'input', 'button', 'iframe', 'object', 'embed', 'svg', 'math', 'link', 'meta'],
    FORBID_ATTR: ['style', 'srcset'],
  })
}

export const escapeHtml = (s: string) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!)
export const textToEditorHtml = (t: string) => t.split(/\n{2,}/).map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`).join('')
